define(
//begin v1.x content
{
	"group": ".",
	"decimal": ","
}
//end v1.x content
);